import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { actionTypes } from '../actionTypes';
import { requestForToken } from '../../firebase';
import Server from '../../api';
// import { HandleExceptionWithSecureCatch } from './CombineCatch';

export const loginAdmin = createAsyncThunk(actionTypes.ON_LOGIN, async (params, thunkAPI) => {
  try {
    const response = await Server.post('admin/login', params);
    console.log('response of login', response);
    // HandleExceptionWithSecureCatch(response);

    if (response.data.data[0]) {
      localStorage.setItem('token', response.data.data[0].token);
    }

    return response;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const logoutAdmin = createAsyncThunk(actionTypes.ON_LOGOUT, async () => {
  try {
    localStorage.clear();
    console.log('logout sucessfully');
  } catch (e) {
    console.log('logout failed');
  }
});
